"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlertBaseColorStyleName = exports.ColorMap = exports.AlertType = void 0;
var tslib_1 = require("tslib");
var TypeStyle = tslib_1.__importStar(require("typestyle"));
var AlertType;
(function (AlertType) {
    AlertType["Success"] = "success";
    AlertType["Info"] = "info";
    AlertType["Warning"] = "warning";
    AlertType["Error"] = "error";
})(AlertType = exports.AlertType || (exports.AlertType = {}));
exports.ColorMap = {
    success: {
        accentColor: '#ACE5C8',
        borderColor: '#008057',
        backgroundColor: '#F2F8F6',
        hoverColor: '#E5F1ED',
    },
    info: {
        accentColor: '#D7ECF9',
        borderColor: '#2979B2',
        backgroundColor: '#EEF5FB',
        hoverColor: '#DEEBF3',
    },
    warning: {
        accentColor: '#FBEDA4',
        borderColor: '#FECA56',
        backgroundColor: '#FEF9EF',
        hoverColor: '#FDF3E0',
    },
    error: {
        accentColor: '#F8C7CB',
        borderColor: '#C93A47',
        backgroundColor: '#F9EBEC',
        hoverColor: '#F3D8DA',
    },
};
exports.AlertBaseColorStyleName = TypeStyle.style({
    $nest: (_a = {},
        _a["&." + AlertType.Success] = {
            backgroundColor: exports.ColorMap.success.backgroundColor,
            borderColor: exports.ColorMap.success.borderColor,
        },
        _a["&." + AlertType.Info] = {
            backgroundColor: exports.ColorMap.info.backgroundColor,
            borderColor: exports.ColorMap.info.borderColor,
        },
        _a["&." + AlertType.Warning] = {
            backgroundColor: exports.ColorMap.warning.backgroundColor,
            borderColor: exports.ColorMap.warning.borderColor,
        },
        _a["&." + AlertType.Error] = {
            backgroundColor: exports.ColorMap.error.backgroundColor,
            borderColor: exports.ColorMap.error.borderColor,
        },
        _a)
});
//# sourceMappingURL=AlertStyles.js.map